// extracted by mini-css-extract-plugin
export default {"Container":"CargoUnitItem_Container__KunWq","Label":"CargoUnitItem_Label__d80hT","Field":"CargoUnitItem_Field__NVFPk"};